import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=848e7b94&scoped=true&"
import script from "./WhyChooseUs.vue?vue&type=script&lang=ts&"
export * from "./WhyChooseUs.vue?vue&type=script&lang=ts&"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=848e7b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848e7b94",
  null
  
)

export default component.exports